import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@app/components/ui/alert-dialog";
import useUser from "@app/zustand/user";
import { Trans } from "@lingui/macro";

/**
 * Says why the reader is back on the login page after a session ended by itself (PT-171).
 *
 * Here rather than over the page that lapsed: a dialog on a dossier would leave it readable behind
 * it until somebody clicked, and clearing that screen is the point.
 */
export default function SessionLapsedDialog() {
  const lapsedSession = useUser((state) => state.lapsedSession);
  const dismiss = useUser((state) => state.dismissLapsedSession);
  if (!lapsedSession) return null;
  const { minutes } = lapsedSession;

  return (
    <AlertDialog open onOpenChange={(open) => !open && dismiss()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            <Trans>Session fermée</Trans>
          </AlertDialogTitle>
          <AlertDialogDescription>
            {minutes ? (
              <Trans>
                Inactivité depuis plus de {minutes} min. Veuillez vous
                reconnecter.
              </Trans>
            ) : (
              <Trans>Inactivité prolongée. Veuillez vous reconnecter.</Trans>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction>
            <Trans>OK</Trans>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
